import * as React from "react";
// import i18n from 'i18n';
import classNames from 'classnames';

import Link from "../Link";
import { Image, Link as LinkType } from "../../types";

import CardVideo from '../CardVideo';
import { CardVideoProps } from '../CardVideo/CardVideo';

import s from './CardOffer.module.scss';

export interface CardOfferProps {
    title: string,
    description: string,
    articles: Array<any>,
    projects: Array<any>,
    extraLinks: Array<any>,
    extraLinksTitle: string,
    icon: Image,
    video: CardVideoProps,
    showSmallVideo: boolean
}

const CardOffer: React.FC<CardOfferProps> = (props) => {
    const { title, description, projects, articles, extraLinks, extraLinksTitle, icon, video, showSmallVideo = false } = props;

    const videoClasses = classNames(s.Video, {
        [s['Video--Small']]: showSmallVideo
    });

    return (
        <article className={s.Root}>
            {video && video.videoUrl &&
                <div className={videoClasses}>
                    <CardVideo {...video} />
                </div>
            }

            <div className={s.Content}>
                <div className={s.TitleWrapper}>
                    {icon && icon.src && (
                        <div
                            className={s.Icon}
                            style={{
                                backgroundImage: `url(${icon.src})`
                            }}
                        />
                    )}

                    <h2 className={s.Title}>
                        {title}
                    </h2>
                </div>

                {description && (
                    <div
                        className={s.Description}
                        dangerouslySetInnerHTML={{__html: description}}
                    />
                )}

                <div className={s.Lists}>
                    {projects && !!projects && (
                        <List
                            // title={i18n.t('offer.projects')}
                            title="Projekt"
                            items={projects}
                        />
                    )}
                    {articles && !!articles && (
                        <List
                            // title={i18n.t('offer.articles')}
                            title="Artiklar"
                            items={articles}
                        />
                    )}
                    {extraLinks && extraLinksTitle && !!extraLinks && (
                        <List
                            // title={i18n.t('offer.articles')}
                            title={extraLinksTitle}
                            items={extraLinks}
                        />
                    )}
                </div>
            </div>
        </article>
    )
};

const List = ({ items, title }) => {

    var isEmpty = items && items.length === 1 && Object.entries(items[0]).length === 0;

    if (isEmpty) {
        return <></>;
    }

    return (
        <div className={s.ListWrap}>
            <h3 className={s.ListTitle}>
                {title}
            </h3>
            <ul className={s.List}>
                {items.map((item, index) => {
                    return (
                        <li key={index} className={s.ListItem}>
                            <Link className={s.ListItemLink} key={index} href={item.href}>
                                {item.title}
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default CardOffer
